import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { distinctUntilChanged, filter, first, map, mergeMap, tap } from 'rxjs/operators'
import { AuthenticationService } from '../../../access/shared/authentication/authentication.service'
import { ConfigService } from '../../../config/config.service'
import { Client, ClientConcat } from './client'

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  currentClient$: BehaviorSubject<Client>
  modifCodeService

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private authenticationService: AuthenticationService
  ) {
    this.currentClient$ = new BehaviorSubject<Client>(null)
    this.authenticationService.currentUser$.subscribe(user => {
      this.selectClient(undefined)
    })
  }

  getCurrentClient() {
    return this.currentClient$.pipe(filter(client => client != null), distinctUntilChanged((prev, next) => prev.id == next.id))
  }

  getFirstCurrentClient() {
    return this.currentClient$.pipe(filter(client => client != null), first())
  }

  getClients(filter: string = ""): Observable<Array<Client>> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Array<Client>>(config.apiPoint + config.getClients,
          {
            params: {
              filter: filter
            }
          }).pipe(
            tap(clients => {
              if (this.currentClient$.getValue() == null) this.selectClient(clients[0])
            })
          )
      })
    )
  }

  getClient(id: string): Observable<Client> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Client>(config.apiPoint + config.getClient.replace("{client}", id))
      })
    )
  }

  selectClient(client: Client) {
    this.currentClient$.next(client)
  }

  displayFn(client?: Client): string | undefined {
    return client ? (client.site == null ? '' : client.site.numero + ': ') + client.code_client + "/" + client.code_service + " - " + client.raison_sociale : undefined
  }

  getClientConcat(id: string): Observable<ClientConcat> {
    return this.getClient(id).pipe(
      map(client => {
        return {
          id: client.id,
          full_name: client.code_client + "/" + client.code_service + " - " + client.raison_sociale
        }
      })
    )
  }

  postLastAccess(client, user): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<Observable<any>>(config.apiPoint + config.postClientLastAccess.replace('{client}', client), { 'id': user.id });
      })
    );
  }
}
